export default __webpack_public_path__ + "static/media/huisjes2.fa47fb59.jpg";